export default function modelsReducer(state = [], { type, id, payload }) {
  let newState = ''
  switch (type) {
    case 'modelsInitialStore':
      if (payload === null) {
        console.error('Error in models initial store')
        return []
      }
      if (!payload[0]) {
        console.warn('No models in store!')
        return []
      }
      if (!payload[0].models) {
        console.warn("model's store empty!")
        return []
      }
      return payload[0].models

    case 'modelNew':
      newState = Object.values(state)
      newState.unshift(payload)
      return { ...newState }

    case 'atualizaSinal':
      newState = Object.assign({}, state)
      Object.entries(newState).forEach((data) => {
        if (id === data[1].id) {
          //console.log('Paypay', payload);
          switch (payload.campo) {
            case 'Cor':
              newState[data[0]].info.color = payload.valor
              break
            case 'Nome':
              newState[data[0]].name = payload.valor
              break
            default:
              console.log('Erro no models reducer, atualiza Sinal sem campo preparado para atualizar')
          }
        }
      })
      return Object.assign({}, state, newState)

    case 'updatemodelNew':
      newState = Object.assign({}, state)
      Object.entries(newState).forEach((data) => {
        if (payload.id === data[1].id) {
          newState[data[0]].name = payload.name
          return newState
        }
      })
      return Object.assign({}, state, newState)

    case 'deletaSinais':
      newState = state
      Object.entries(newState).forEach((data) => {
        if (payload.indexOf(data[1].id) !== -1) delete newState[data[0]]
      })
      return { ...newState }

    case 'updatedeletemodelNew':
      newState = Object.assign({}, state)
      Object.entries(newState).forEach((data) => {
        if (payload.id === data[1].id) delete newState[data[0]]
      })
      return Object.assign({}, newState)
    default:
      return state
  }
}
